export default __webpack_public_path__ + "static/media/Skeleton-3D-Model-Rigged-04.754f67f6.jpg";